import React, { useContext } from 'react'
import './Load.css'
import { GetUserContext } from '../Context/GetUserContext'

const Load = () => {
    const { size } = useContext(GetUserContext)
    return (
        size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?

            (<div className='area-load-mobile'>
                <div className="loader-circle-mobile"></div>
            </div>)
            :
            (
                <div className='area-load'>
                    <div className="loader-circle"></div >
                </div >
            )


    )
}

export default Load

